function buySectionLocaleChanges () {
  if (window.theme.settings.template !== 'product.supadu') return
  const addToCart = document.querySelector('.add-to-cart')
  const buyForm = document.querySelector('.js-product-single__form')
  const shopLocale = window.theme.settings.geolocationCountryCode
  const languageLocale = window.theme.settings.shopLocale
  if (!shopLocale) return
  if (shopLocale === 'ES') {
    // hardcode to always display buy button for ES & US geolocation,
    // strange bug preventing days_before_buy_now value working on Spanish language selector
    buyForm.style.display = 'block'
  } else if (shopLocale === 'US') {
    buyForm.style.display = 'block'
    const item = window.theme.staticProductData
    if (!item) return
    const { isbn13, title } = item
    if (!isbn13 || !title) return
    const addToCartLink = `https://add-to-cart-2.supadu.com/add-to-cart?isbn=${isbn13}&client=indiepubs-cuento-de-luz`
    addToCart.style.display = 'none'
    const buyText = languageLocale === 'es' ? 'Añadir a Carrito' : 'Add to cart'
    const smartBuyButton = `
      <a class="btn btn--full add-to-cart" href="${addToCartLink}" target="_blank" title="${title}">
        <span>${buyText}</span>
      </a>
    `
    const buyContainer = document.querySelector('.js-product-form__switch-format')
    buyContainer.insertAdjacentHTML('beforeend', smartBuyButton)
  } else {
    buyForm.style.display = 'none'
  }

  // translate buy text based on language locale, if not already done in add to cart link
  const buyLabel = addToCart.querySelector('span')
  if (languageLocale === 'es') {
    buyLabel.innerText = 'Añadir a Carrito'
  } else {
    buyLabel.innerText = 'Add to cart'
  }
}

function modifyResourcesTranslations () {
  if (window.theme.settings.template !== 'product.supadu') return
  const pdfElements = document.querySelectorAll('.sp__pdf')

  pdfElements.forEach((pdfElement) => {
    const title = pdfElement.getAttribute('title')
    if (title === 'Teaching Guide') {
      pdfElement.childNodes[1].textContent = "Teacher's Guide"
    }
    if (title === 'Guía Didáctica') {
      pdfElement.childNodes[1].textContent = 'Guía para docentes'
    }
  })
}

function showCartIconSpain () {
  const locale = window.theme.settings.geolocationCountryCode
  if (!locale) return
  if (locale !== 'ES') return
  const cartIcon = document.querySelector('.js-drawer-open-cart')
  cartIcon.style.display = 'inline-block'
}

function customFunctions () {
  buySectionLocaleChanges()
  showCartIconSpain()
  modifyResourcesTranslations()
}

module.exports = { customFunctions }
